module.exports = __webpack_public_path__ + "static/img/64.98b03e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/64.png
// module id = 99lJ
// module chunks = 1